import { useOptimizelyFlag } from 'src/services/flags/hooks/useOptimizelyFlag';

export const useIsPaymentsEnabled = (): boolean => {
  const { enabled } = useOptimizelyFlag('payments_enabled');
  return enabled;
};
